<template src="./vehiclechecks.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
var moment = require("moment");
export default {
  props: ["NewVehicle", "type"],

  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      ImageEndpoint: Endpoints.Helper.Image + "/",
      VehicleChecks: [],
      checks_excel_data: [],
      fromDate: "",
      toDate: "",
      vrm: "",
      SearchData: false,
      ShowVehicleNotesModel: false,
      VehicleNotes: "",
      ShowVehicleNotesModelHeading: "Notes",
      ShowFailedCheckModel: false,
      FailedChecks: [],
      SafeNotes: "",
      date_fixed: "",
      PopupLoader: false,
      SubmitFailedChecksNotes: {},      
    };
  },
  mounted() {
    setTimeout(() => {
      this.GetVehicleChecksList();
    }, 3000);
  },
  methods: {
    GetVehicleChecksList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.vrm = this.vrm;
        obj.fromDate = this.fromDate;
        obj.toDate = this.toDate;
      }
      this.SearchData = true;
      if (this.type === "Asset") {
        obj.assetId = this.NewVehicle.id;
      } else {
        obj.vehicleId = this.NewVehicle.id;
      }
      obj.requestFor = this.type;
      this.ShowLoader = true;
      Axios.post(Endpoints.VehicleChecks.VehicleChecksList, obj).then(
        (Response) => {
          this.ShowLoader = false;
          this.SearchData = false;
          if (Response.data.success) {
            this.VehicleChecks = Response.data.FleetCheckSubmit;
            //this.CompanyChecks = Response.data.CompanyChecks;
            this.checks_excel_data = [];
            if (this.VehicleChecks.length > 0) {
              this.VehicleChecks.forEach((element) => {
                var obj = {};
                var status = "";
                obj["Date"] = element.created_at;
                obj["VRM"] = element.vehicle.vrm;
                obj["Driver"] =
                  element.driver.forename + " " + element.driver.surname;
                obj["Check"] = element.safe == 1 ? "Pass" : "Fail";
                obj["Note"] = element.notes;
                this.checks_excel_data.push(obj);
              });
            }
          }
        }
      );
    },
    ShowVehicleNotes(VehicleCheck, type = "notes") {
      if (VehicleCheck.notes != null && VehicleCheck.notes != "") {
        this.ShowVehicleNotesModel = true;
        this.VehicleNotes = VehicleCheck.notes;
        this.ShowVehicleNotesModelHeading = "Notes";
      }
    },
    SubmitAllFailedChecks($event){
        this.SubmitFailedChecks={'Id':{},'Notes':{}}
        if($event.target.checked){
            this.FailedChecks.forEach((element) => {
                this.SubmitFailedChecks['Id'][element.id]=true
            })            
        }else{
            this.FailedChecks.forEach((element) => {
                this.SubmitFailedChecks['Id'][element.id]=false
            })
        }
    },
    MarkSafe() {
        this.ShowFailedCheckModel = true;
        var obj = { token: localStorage.getItem("token") };
        obj.vehicleId = this.NewVehicle.id;
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleChecks.GetVehicleFailedCheckVehicle, obj).then((Response) => {
            this.ShowLoader = false;
            if (Response.data.success) {
                this.FailedChecks = Response.data.FailedChecks;
            }
        });
    },
    MarkSafeSubmit(){        
        if(this.SafeNotes == "") {
            this.$swal("Following Error Found!", "Please Enter Notes", "error").then(() => {});
        }else if(this.date_fixed == "") {
            this.$swal("Following Error Found!", "Please Enter Date Fixed", "error").then(() => {});
        }else{            
            var obj = { token: localStorage.getItem("token") };
            obj.vehicleId = this.NewVehicle.id;
            obj.date_fixed = this.date_fixed;
            obj.notes = this.SafeNotes;
            obj.SubmitFailedChecksNotes = this.SubmitFailedChecksNotes;
            obj.FailedChecks = this.FailedChecks;
            obj.type = this.type;
            this.PopupLoader = true;
            Axios.post(Endpoints.VehicleChecks.MarkSafeVehicle, obj).then((Response) => {
                this.PopupLoader = false;
                if (Response.data.success) {                   
                    this.ShowFailedCheckModel = false;
                    this.$swal("Vehicle Check Marked Safe Successfully", "", "success").then(() => {
                        window.location.reload();
                    });                    
                }
            })
        }
    },
  },
};
</script>
<style scoped>
.vehicle-check-div {
  height: 177px;
  overflow-y: scroll;
  padding-right: 17px;
}
</style>
